export const FLOOR_PLAN_SECTION_EVENT = 'canvas-agent:floor-plan:section';
export const FLOOR_PLAN_FILTER_EVENT = 'canvas-agent:floor-plan:filter';
export const FLOOR_PLAN_FOCUS_EVENT = 'canvas-agent:floor-plan:focus';
export const FLOOR_PLAN_CREATE_MODAL_EVENT =
	'canvas-agent:floor-plan:create-modal';
export const FLOOR_PLAN_CONFIGURE_MODAL_EVENT =
	'canvas-agent:floor-plan:configure-modal';
export const FLOOR_PLAN_PREVIEW_MODAL_EVENT =
	'canvas-agent:floor-plan:preview-modal';
export const FLOOR_PLAN_DELETE_MODAL_EVENT =
	'canvas-agent:floor-plan:delete-modal';
